module.exports = __webpack_public_path__ + "img/block-2.8c12c3c6.png";